<template>
  <div class="content" v-if="oneContentObj.title">
    <h1 class="title_h1">{{ oneContentObj.title }}</h1>
    <div class="cont_date title_h1">{{ content }}</div>
    <hr />
    <div v-html="oneContentObj.historyBody"></div>
    <hr />
    <!-- 数据来源 -->
    <div class="cont_source">来源：{{ oneContentObj.historySource }}</div>
  </div>
  <h3 style="text-align: center;" v-else>暂无数据</h3>
</template>
<script setup>
import { defineProps, onMounted, computed,watch } from 'vue';
const props = defineProps({
  oneContentObj: {
    type: String,
  }
})
let content = ref('')
const formDate = ((val) =>{
  const date = val.split('-')
  content = date[0] + '年' + date[1] + '月' + date[2] + '日';
}) 

watch(() => props.oneContentObj,(val) =>{
  if(val){
    formDate(props.oneContentObj.releaseDate)
  }
})


onMounted(() => {
  nextTick(() => {
    
  })
})
</script>


<style scoped lang='scss'>
.content {
  width: 1200px;
  // margin: 50px auto;
  padding: 50px 20px;
  box-sizing: border-box;
  background-color: #FFFFFF;
}

.cont_date {
  font-size: 14px;
  color: #CCCCCC;
  line-height: 60px;
}

.cont_source {
  font-size: 14px;
  color: #CCCCCC;
  text-align: left;
}

.title_h1 {
  text-align: center;
}
</style>